import React, { Component } from 'react';
import { withDomains, RESTExecutor } from '../../../lib/domain';
import { Row, Table, Button, Input } from 'antd';
import Title from 'antd/lib/typography/Title';
import { Link } from 'react-router-dom';
import { PopUpForm } from '../../../lib/ui/popupform';
import { formatMoney } from '../../../lib/util';


const parsers_cols = ({ onEditPressed }) => [
    {
        title: "Parser Name",
        dataIndex: "name",
        key: 'name'
    },
    {
        title: "Version",
        dataIndex: 'version',
        key: 'version'
    },
    {
        title: "ID",
        dataIndex: 'id',
        key: 'id'
    },
    // {
    //     title:"",
    //     dataIndex:'id',
    //     key:'action',
    //     render:(id,data)=><Button 
    //     type='link'
    //     onClick={()=>{
    //         typeof onEditPressed==='function'&&onEditPressed(data)
    //     }}>Edit</Button>

    // }
]

const parser_fields = [
    {
        index: 'id',
        name: "Parser ID",
        type: 'text',
        show_update: false
    },
    {
        index: 'name',
        name: "Parser Name",
        type: 'text'
    },
    {
        index: 'version',
        name: "Version",
        type: 'text'
    },
    {
        index: 'validation_config',
        name: "Validation Config",
        type: 'json'
    }
]
class ParsersView extends Component {
    constructor(props) {
        super(props)

        this.state = {
            form_visibility: false,
            form_data: {},
            edit_id: null
        };

        this.list_parsers = RESTExecutor.list().config({
            label: 'parsers'
        }).connect(props.domains.settings);


        this.post_parsers = RESTExecutor.post().config({
            label: 'parsers'
        }).callbacks((success) => {
            this.list_parsers.execute();

            this.setState({
                form_visibility: false,
                form_data: {},
                edit_id: null
            })
        })
            .connect(props.domains.settings);

        this.patch_parser = RESTExecutor.patch().config({
            label: 'parsers_detail'
        }).forId("").callbacks((success) => {
            this.list_parsers.execute();

            this.setState({
                form_visibility: false,
                form_data: {},
                edit_id: null
            })

        }).connect(props.domains.settings);
    }


    handlePostPatch = (data) => {
        if (this.state.edit_id) {
            this.patch_parser.forId(this.state.edit_id).execute(data);
        } else {
            this.post_parsers.execute(data);
        }
    }

    render() {

        let list_parsers_res = this.list_parsers.response();
        let list_parsers_data = list_parsers_res.result || {};
        let post_parser_resp = this.post_parsers.response();
        let patch_parser_resp = this.patch_parser.response();
        let rowsMeta = list_parsers_res.meta || {};



        let rowsData = list_parsers_data.rows || [];

        let filteredData = JSON.parse(JSON.stringify(rowsData));
        if (this.state.query) {
            filteredData = filteredData.filter(({ name = "", id = "", description = "" }) => {
                name = name.toLowerCase();
                id = id.toLowerCase();
                description = description.toLowerCase();
                return name.includes(this.state.query.toLowerCase())
                    || id.includes(this.state.query.toLowerCase())
                    || description.includes(this.state.query.toLowerCase())
                    ;
            });
        }

        return (
            <div>
                <Table
                loading={list_parsers_res.fetching}
                scroll={{x:true}}
                    columns={parsers_cols({
                    })}
                    pagination={{
                        showTotal:(total,range)=>`${formatMoney(range[0],0)}-${formatMoney(range[1],0)} of ${formatMoney(total,0)} items`
                        }}
                    dataSource={filteredData}
                    className='main-table  '
                    size='small'
                    title={() => <div><Row type='flex' justify='space-between' style={{
                        alignItems: 'center'
                    }}><Title
                        type='secondary'
                        level={3}

                        style={{
                            margin: 0
                        }}>Parser List</Title>
                    </Row>
                        <br></br>
                        <Row type='flex'
                            justify='space-between'
                            style={{
                                alignItems: 'center',
                                flexWrap: 'nowrap'
                            }}>
                            <Input.Search
                                placeholder="Search For"
                                style={{
                                }}
                                autoFocus
                                value={this.state.query}
                                onChange={(e) => {
                                    this.setState({ query: e.target.value })
                                }}
                            /> {this.state.query && this.state.query.length > 0 && <Button
                                style={{
                                    marginLeft: 4
                                }}
                                type='danger'
                                shape="circle"
                                icon="close-circle"
                                onClick={() => {
                                    this.setState({ query: null })
                                }} />}
                        </Row>
                    </div>}
                    rowKey={(record) => record.id}
                />
            </div>
        )
    }

    componentDidMount() {
        this.list_parsers.execute()
    }
}

export default withDomains(ParsersView, "settings");
